import { StyleSheet, Text } from 'react-native';

import { AppColors, AppStyles } from '../services/styles';

const ParagraphSizes = {
  TINY: 'TINY',
  SMALL: 'SMALL',
  NORMAL: 'NORMAL'
};

const Paragraph = (props) => {
  const style = props.style || {};
  const size = props.size || ParagraphSizes.NORMAL;
  const bold = !!props.bold;
  const { children, ...textProps } = props;
  return (
    <Text
      {...textProps}
      style={[
        styles.paragraph,
        styles[`paragraph${size}`],
        bold ? styles.paragraphBold : {},
        style
      ]}
    >
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  paragraph: {
    fontFamily: AppStyles.fontFamily,
    color: AppColors.darkText
  },
  paragraphBold: {
    fontFamily: AppStyles.fontFamilyBold,
    fontWeight: AppStyles.boldWeight
  },
  paragraphTINY: {
    fontSize: AppStyles.tinyTextSize,
    lineHeight: AppStyles.tinyTextHeight
  },
  paragraphSMALL: {
    fontSize: AppStyles.smallTextSize,
    lineHeight: AppStyles.smallTextHeight
  },
  paragraphNORMAL: {
    fontSize: AppStyles.normalTextSize,
    lineHeight: AppStyles.normalTextHeight
  }
});

export { Paragraph, ParagraphSizes };
